import { useSelector } from 'react-redux'
import { Core } from '../../../../../../types/Survey/Element'
import props from '../../../../../../redux/props'
import Modal from '../../../../../UI/Modal/Modal'
import { s3PublicStoragePrefix } from '../../../../../../utility'
import { useState } from 'react'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid'

type Props = {
  element: Core<any>
  small?: boolean
}

const CoreInfoContent: React.FC<Props> = ({ element, small }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [show, setShow] = useState(false)

  const toggle = () => setShow(!show)

  if (!element.infoImageKey && !element.infoText) return null
  return (
    <>
      <QuestionMarkCircleIcon onClick={toggle} className="w-5 fill-cyan cursor-pointer inline-block" />
      {/* <div onClick={toggle} className={`text-cyan underline cursor-pointer whitespace-pre-wrap ${small && 'text-sm'}`}>
        {t.survey.answer.infoContent.label}
      </div> */}
      <Modal noForm large show={show} onClose={toggle} title={t.survey.answer.infoContent.title}>
        <div className="flex flex-col gap-3">
          <div className="text-gray whitespace-pre-wrap">{element.infoText}</div>
          {element.infoImageKey && (
            <img
              src={`${s3PublicStoragePrefix}${element.infoImageKey}`}
              alt={element.title}
              className="max-h-[50vh] object-contain w-full py-3 bg-white"
            />
          )}
        </div>
      </Modal>
    </>
  )
}

export default CoreInfoContent
